import React, { useEffect, useRef } from 'react';
import { useMobile } from '../../hooks/useMobile';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Questions from './Results/Questions';
import AnswerWith8Fig from './Results/AnswerWith8Fig';
import QuestionsAndAnswerForMobile from './Results/QuestionsAndAnswerForMobile';

const useStyles = makeStyles((theme: any) => ({
  divContainer: {
    backgroundColor: theme.palette.brand.greyMid,
    padding: theme.spacing(3),
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
    },
    borderRadius: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
  },
}));

interface ICalculateResult {
  netCapital: string;
  netCapitalMin: number;
  netCapitalMax: number;
  time: string;
}
export default function CalculateResult({
  netCapital,
  netCapitalMin,
  netCapitalMax,
  time,
}: ICalculateResult) {
  const mobile = useMobile();
  const classes = useStyles();
  const focusDiv = useRef(null);

  useEffect(() => {
    if (focusDiv?.current)
      focusDiv.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [focusDiv]);

  return (
    <div className={classes.divContainer} ref={focusDiv}>
      {mobile && (
        <QuestionsAndAnswerForMobile
          netCapital={netCapital}
          netCapitalMin={netCapitalMin}
          netCapitalMax={netCapitalMax}
          time={time}
        />
      )}

      {!mobile && (
        <>
          <Questions />
          <AnswerWith8Fig
            netCapital={netCapital}
            netCapitalMin={netCapitalMin}
            netCapitalMax={netCapitalMax}
            time={time}
          />
        </>
      )}
    </div>
  );
}
